export enum ReportFilterType {
  MultiSelect = "multi-select",
  SingleSelect = "single-select",
  Text = "text"
}